import "./styles/view.scss";
import "../guest-entry-grid/styles/view.scss";

import Swiper from "swiper/bundle";
import 'swiper/swiper-bundle.css';

document.addEventListener("DOMContentLoaded", function () {
    const guestbookEl = document.querySelector('.wp-block-madden-blocks-guestbook');
    if (guestbookEl) {
        new Swiper(guestbookEl, {
            lazy: { loadPrevNext: true },
            effect: 'fade',
            loop: true,
            pagination: {
                el: '.guestbook-swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.guestbook-swiper-button-next',
                prevEl: '.guestbook-swiper-button-prev',
            },
        });
    }
});
